import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { BSpinner } from "bootstrap-vue";

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('b-spinner', BSpinner)
